import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

import CustomErrorPage from 'src/pageContainers/CustomErrorPage'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}
export default function Error({ error, reset }: Props) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return <CustomErrorPage onReload={reset} />
}
